import React from "react";
import ResultsSection from "../../components/tools/founders/pitch-deck-analysis/components/sections/results-section";

/**
 * PitchDeckContentLayout Component
 * 
 * Simple wrapper layout for pitch deck form tabs. Displays form questions/content on left side
 * and AI analysis results on right side in a two-column layout. Used within TabContent to
 * structure the question prompts alongside their corresponding analysis results.
 * 
 * @param {React.ReactNode} children - Form questions/input section JSX
 * @param {Object} data - Analysis data object containing results
 * @param {string} type - Type of analysis being displayed (determines results formatting)
 * @returns {JSX.Element} Two-column layout with questions on left and results on right
 */
const PitchDeckContentLayout = ({ children, data, type }) => {
  return (
    <div className="ideacheckertabbody">
      <div className="ideacheckerquestions">{children}</div>

      <ResultsSection data={data.results} type={type} />
    </div>
  );
};

export default PitchDeckContentLayout;
